module.exports = __webpack_public_path__ + "img/MUSA-7.c3298f29.jpg";